import { useEffect, useState } from 'react';

import { usePostQuery } from '@/queries/usePostQuery';
import { Defect } from '@/types/Defecten';
import { bmsApiResponseHandler, responseToToastHandler } from '@/utils/bmsApiResponseHandlers';

const useDefectGereedMeldenDialog = (handleOpenChange: (open: boolean) => void) => {
  const [defectenUrl, setDefectenUrl] = useState<string>('');
  const { post } = usePostQuery<null, Defect>(defectenUrl);

  const [selectedDefects, setSelectedDefects] = useState<number[]>([]);
  const [error, setError] = useState(false);
  const handleCheckboxChange = (defectId: number, isChecked: boolean) => {
    if (isChecked) {
      setSelectedDefects((prevState) => [...prevState, defectId]);
    } else {
      setSelectedDefects((prevState) => prevState.filter((id) => id !== defectId));
    }
  };

  useEffect(() => {
    const defectIdsParam = selectedDefects.map((defectId) => `defectId=${defectId}`).join('&');
    setDefectenUrl(`/defecten/melddefectgereed?${defectIdsParam}`);
  }, [selectedDefects]);

  // reset all values
  const resetDialog = (closeButtonCLick: boolean) => {
    if (closeButtonCLick) {
      handleOpenChange(false);
    }
    setSelectedDefects([]);
    setDefectenUrl('');
  };

  const onSubmit = () => {
    if (selectedDefects.length === 0) {
      setError(true);
      setTimeout(() => setError(false), 2000);
      return;
    }

    void (async () => {
      try {
        const postDefectGereedmeldenResponse = await post(null);
        const message = bmsApiResponseHandler(
          postDefectGereedmeldenResponse ? 'SUCCES' : 'ERROR',
          'defect-gereedmelden',
        );
        responseToToastHandler(message);
        if (message.type === 'success') resetDialog(true);
      } catch (error: unknown) {
        setSelectedDefects([]);
        setDefectenUrl('');
        // form validation error (most likely).
        responseToToastHandler({
          type: 'error',
          message: 'Onverwachte fout: Probeer het defect opnieuw niet inzetbaar te maken.',
        });
        console.error({ error });
      }
    })();
  };

  return {
    error,
    selectedDefects,
    handleCheckboxChange,
    resetDialog,
    onSubmit,
  };
};
export default useDefectGereedMeldenDialog;
